import { render, staticRenderFns } from "./Stuff.vue?vue&type=template&id=3f6023c1&"
import script from "./Stuff.vue?vue&type=script&lang=js&"
export * from "./Stuff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports